import { Checkbox } from "@mui/material";
import styled from "styled-components";
import Colors from "../../constants/Colors";
import { Text } from '../UI/generalLayout/Layout.styled'
import { UnitCircle } from "./AgendaProfissionalListItem.styled";

export const StyledText = styled(Text)<{disabled?: boolean}>`
    color: ${Colors.SPM800};
    font-size: 14px;
    font-weight: bold;
    opacity: ${props=>props.disabled? '0.5':'1'};
`

export const StyledCheckbox = styled(Checkbox)`
    color: ${Colors.SPM500} !important;
`

export const StyledUnitCircle = styled(UnitCircle)`
    margin-top: 6px; 
    margin-right: 5px;
`